module.exports = __webpack_public_path__ + "img/rubberproducts_icon.8f94048b.svg";